import type { CSSProperties, ElementType, ReactNode } from 'react';
import { FONTS } from './tokens';

export interface TypographyProps {
  children: ReactNode;
  style?: CSSProperties;
}

export function Mono({ children, style }: TypographyProps) {
  return (
    <span
      style={{
        fontFamily: FONTS.mono,
        fontFeatureSettings: "'ss01', 'cv11'",
        ...style,
      }}
    >
      {children}
    </span>
  );
}

export interface SerifProps extends TypographyProps {
  as?: ElementType;
}

export function Serif({ children, style, as: Tag = 'span' }: SerifProps) {
  return (
    <Tag
      style={{
        fontFamily: FONTS.serif,
        letterSpacing: '-0.01em',
        ...style,
      }}
    >
      {children}
    </Tag>
  );
}

export function SerifItalic({ children, style, as }: SerifProps) {
  return (
    <Serif as={as} style={{ fontStyle: 'italic', ...style }}>
      {children}
    </Serif>
  );
}
